export default __webpack_public_path__ + "static/media/kyykka_4.67be3bb6.jpg";